<template>
    <PopupContainer>
        <template #header><div class="header"><span class="title">隐私政策</span></div></template>
        <div style="padding: 20px 5px;">
            <div class="dialog-content">
                您在使用我们的服务时，我们可能会收集和使用您的相关信息。为了更好保障您的合法权益，请仔细阅读
            <div class="agreement" style=" cursor: pointer;" @click="privacyPolicy">
            《隐私政策》
            </div>
            充分理解协议中的内容后点击同意。
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="popup.done()">不同意</el-button>
                <el-button type="primary" @click="popup.done(true)">
                    同意
                </el-button>
            </div>
        </template>
    </PopupContainer>
</template>
<script lang="ts" setup>
import {privacyPolicy} from "@/components/Agreement"
import { PopupCtx, PopupContainer, usePopup } from '@/components/easy';

const props = defineProps<{
  popupCtx?: PopupCtx<true>;
}>();

const popup = usePopup(props);

</script>

<style lang="scss" scoped>
.header {
    text-align: center;
}

.title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
}

//弹窗的隐私政策样式
.agreement {
	display: inline;
	font-size: 15px;
	font-weight: 400;
	color: #3d8eff;
	cursor: pointer;
}

.dialog-footer {
    text-align: center;
    width: 100%;
    padding: 10px 20px 20px 20px;

    :deep(button) {
        height: 30px!important;
        padding: 8px 15px!important;
    }
}
</style>